import { Component } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import config from 'devextreme/core/config'  

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent{

  constructor() {
    loadMessages({
        "en": {
            "Yes": "Sí"
        }
    });

    config({
      "decimalSeparator":",",
      "thousandsSeparator":"."
    });
}

}
